import axios from "axios";
import qs from "qs";
export class MapboxAPIClass {
    constructor(opts) {
        this.request = async (opts) => {
            try {
                const response = await axios({
                    url: `https://api.mapbox.com${opts.path}`,
                    method: opts.method || "get",
                    data: opts.data || {},
                });
                return response.data;
            }
            catch (e) {
                if (e.response && e.response.data) {
                    throw e.response.data;
                }
                else {
                    throw e;
                }
            }
        };
        this.directions = async (profile, from, to, opts) => {
            const query = qs.stringify({
                access_token: this.opts.api_key,
                ...(opts || {}),
            });
            const coordinates = `${from[0]},${from[1]};${to[0]},${to[1]}`;
            const path = `/directions/v5/${profile}/${coordinates}?${query}`;
            return this.request({ method: "get", path: path });
        };
        this.geocode_autocomplete = async (search, opts) => {
            const query = qs.stringify({
                access_token: this.opts.api_key,
                ...(opts || {}),
            });
            const searchText = encodeURI(search);
            return this.request({
                method: "get",
                path: `/geocoding/v5/mapbox.places/${searchText}.json?${query}`,
            });
        };
        this.opts = opts;
    }
}
//# sourceMappingURL=index.js.map